import { render, staticRenderFns } from "./EventDetectionDataTable.vue?vue&type=template&id=50c554f6&scoped=true"
import script from "./EventDetectionDataTable.vue?vue&type=script&lang=js"
export * from "./EventDetectionDataTable.vue?vue&type=script&lang=js"
import style0 from "./EventDetectionDataTable.vue?vue&type=style&index=0&id=50c554f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c554f6",
  null
  
)

export default component.exports